import React from 'react'
import { Icon, Button, Header, Form, Modal } from 'semantic-ui-react'
import firebase from 'firebase/app'
import moment from 'moment'
import get from 'lodash/get'

import DateField from '../../../../components/restaurants/fields/dateField'

class RequestCloseStoreForm extends React.PureComponent {
  btnSubmitRef = React.createRef()

  state = {
    startAt: Number(
      moment()
        .startOf('day')
        .format('x')
    ),
    endAt: Number(
      moment()
        .endOf('day')
        .format('x')
    ),
    loading: false,
  }

  componentDidMount() {
    const { temporaryClosed } = this.props

    if (temporaryClosed) {
      this.setState({
        startAt: temporaryClosed.start_at,
        endAt: temporaryClosed.end_at,
      })
    }
  }

  setStateAsync = state => new Promise(resolve => this.setState(state, resolve))

  onSaveClick = () => this.btnSubmitRef.click()

  onBranchChange = (field, date) => this.setState({ [field]: date })

  onSave = async e => {
    try {
      e.preventDefault()

      const { onClose, operator, order } = this.props
      const { startAt, endAt } = this.state

      const operatorName = get(operator, 'username', 'N/A')

      const startedAt = Number(moment(startAt).startOf('day').format('x'))
      const endedAt = Number(moment(endAt).endOf('day').format('x'))

      const data = {
        merchant_id: order.restaurant.key,
        branch_id: order.restaurant.branch.key,
        merchant_name: order.restaurant.name,
        branch_name: order.restaurant.branch.name,
        status: 'pending',
        created_at: Date.now(),
        updated_at: Date.now(),
        started_at: startedAt,
        ended_at: endedAt,
        requested_by: operatorName,
      }

      await this.setStateAsync({ loading: true })

      const closeRequestRef = firebase.firestore().collection('merchant_close_requests').doc()

      await closeRequestRef.set(data)

      await this.setStateAsync({ loading: false })
      onClose()

    } catch (error) {
      alert(error.message || error)
      this.setState({ loading: false })
    }
  }

  render() {
    const { startAt, endAt, loading } = this.state
    const { visible, onClose, order } = this.props

    const merchantName = get(order, 'restaurant.name', 'N/A')
    const branchName = get(order, 'restaurant.branch.name', 'N/A')

    const title = `Request Close (${merchantName} - ${branchName})`
    return (
      <Modal open={visible} size="small" style={{ marginTop: 0 }}>
        <Header content={title} />
        <Modal.Content style={{ maxHeight: 500, overflow: 'auto' }} className="hide-scrollbar">
          <Form
            disabled={loading}
            onSubmit={this.onSave}
            ref={ref => {
              this.formRef = ref
            }}
          >
            <Form.Group widths="equal">
              <DateField
                value={startAt}
                label="Branch will be close from"
                onChange={value => this.onBranchChange('startAt', value)}
              />
            </Form.Group>
            <Form.Group widths="equal">
              <DateField
                value={endAt}
                label="Branch will be open after"
                onChange={value => this.onBranchChange('endAt', value)}
              />
            </Form.Group>

            <button
              hidden
              type="submit"
              ref={ref => {
                this.btnSubmitRef = ref
              }}
            />
          </Form>
        </Modal.Content>
        <Modal.Actions>
          <Button onClick={onClose} disabled={loading}>
            Close
          </Button>
          <Button
            icon
            color="black"
            loading={loading}
            disabled={loading}
            onClick={this.onSaveClick}
          >
            <Icon name="checkmark" /> Save
          </Button>
        </Modal.Actions>
      </Modal>
    )
  }
}

export default RequestCloseStoreForm



// WEBPACK FOOTER //
// ./src/containers/orders/components/OrderListItem/RequestCloseStoreForm.js